import { Theme, css } from '@emotion/react';

export const dialogContent = ({ breakpoints, spacing }: Theme) => css`
  padding: 34px 0;
  ${breakpoints.up('sm')} {
    padding: ${spacing(2.5)}px 0;
    & > fieldset {
      margin-bottom: ${spacing(5)}px;
    }
  }
`;

export const sectionHeading = ({ breakpoints, spacing }: Theme) => css`
  margin-left: ${spacing(2.5)}px;
  ${breakpoints.up('sm')} {
    margin-left: ${spacing(3.5)}px;
  }
`;

export const fieldset = ({ breakpoints, spacing }: Theme) => css`
  padding: 0 ${spacing(2.5)}px;
  ${breakpoints.up('sm')} {
    padding: 0 ${spacing(3.5)}px;
  }
`;

export const priceRangeFilter = ({ breakpoints, spacing }: Theme) => css`
  margin: 0 ${spacing(2.5)}px;
  ${breakpoints.up('sm')} {
    margin-bottom: ${spacing(5)}px;
  }
`;

export const dividers = ({ breakpoints }: Theme) => css`
  &:first-of-type {
    display: none;
  }
  ${breakpoints.up('sm')} {
    display: none;
  }
`;
